import Mutations from '../../odata/mutations';

export default { ...new Mutations('keywordHistory'), ...new Mutations('keywordHistories') };
